export default __webpack_public_path__ + "static/media/abi.112f874c.png";